export default "__VITE_ASSET__CeecrNX___"